import React from 'react';
import { Modal, Alert, Typography, Card } from 'antd';
import { IOnboardingAccount } from '../types';

const { Text, Paragraph } = Typography;

interface WelcomeEmailModalProps {
  open: boolean;
  record: IOnboardingAccount | null;
  onClose: () => void;
}

export const WelcomeEmailModal: React.FC<WelcomeEmailModalProps> = ({
  open,
  record,
  onClose,
}) => {
  if (!record) return null;

  return (
    <Modal
      title="Welcome Email Sent"
      open={open}
      centered
      onCancel={onClose}
      onOk={onClose}
      width={700}
      cancelButtonProps={{ style: { display: 'none' } }}
      styles={{
        body: {
          maxHeight: '70dvh',
          overflowY: 'auto',
        },
      }}
    >
      <Alert
        type="success"
        message={
          <span>
            Account created successfully! Welcome email sent to{' '}
            <strong>{record.emailaddress1}</strong>
          </span>
        }
        style={{ marginBottom: 16 }}
      />

      <Card
        title="Email Preview"
        style={{ backgroundColor: '#f9fafb', marginBottom: 16 }}
        size="small"
      >
        <Paragraph>
          <Text strong>To:</Text> {record.emailaddress1}
        </Paragraph>
        <Paragraph>
          <Text strong>Subject:</Text> Welcome to Victorian Sliders CPQ Portal
        </Paragraph>

        <Card style={{ marginTop: 16 }}>
          <Paragraph>Dear {record.name},</Paragraph>
          <Paragraph>
            Welcome to the Victorian Sliders CPQ Portal! Your account has been created.
          </Paragraph>

          <Paragraph>
            <Text strong>Login Details:</Text>
            <br />
            Portal URL: https://portal.victoriansliders.co.uk
            <br />
            Username: {record.emailaddress1}
            <br />
            Temporary Password: (Will be sent separately)
          </Paragraph>

          <Paragraph>
            <Text strong>Next Steps:</Text>
            <br />
            1. Log in to the portal using the credentials above
            <br />
            2. Change your password
            <br />
            3. Complete the setup wizard to configure:
            <br />
            &nbsp;&nbsp;• Your company branding (logo, colors)
            <br />
            &nbsp;&nbsp;• Your pricing margins
            <br />
            &nbsp;&nbsp;• Your terms and conditions
          </Paragraph>

          <Paragraph>
            Support: support@victoriansliders.co.uk | +44 20 7946 0000
          </Paragraph>
        </Card>
      </Card>

      <Alert
        type="warning"
        message={
          <span>
            <Text strong>Note:</Text> Customer will set their own margins, branding, and
            T&Cs in their portal. Victorian Sliders only sets the discount structure (
            {record.dogma_discountpercentage || 0}% off base price).
          </span>
        }
      />
    </Modal>
  );
};
